import getApiClient from 'src/utils/getApiClient'

const apiClient = getApiClient()

/**
 * HTML-фрагмент архивных акций.
 *
 * Эндпоинт тот же, что у старого magnific-popup: Django отдаёт разметку списка.
 */
export default function apiLpuPromotionsArchive(url: string) {
  return apiClient.get<string>(url, {
    responseType: 'text',
  }).then(response => (
    typeof response.data === 'string' ? response.data : ''
  ))
}
